import { createAction } from '@reduxjs/toolkit';

export const fetchCampaign = createAction('campaign/FETCH_ACTIVE_CAMPAIGN', (payload) => ({ payload }));
export const setCampaign = createAction('campaign/SET_ACTIVE_CAMPAIGN', (payload) => ({ payload }));
export const clearCampaign = createAction('campaign/CLEAR_ACTIVE_CAMPAIGN');
export const viewPromotion = createAction<unknown>('campaign/VIEW_PROMOTION');
export const selectPromotion = createAction<unknown>('campaign/SELECT_PROMOTION');
